var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"p-2 text-center"},[_c('p',{staticClass:"text-yellow-700 text-xs text-center"},[_vm._v(" Versión: "+_vm._s(_vm.version)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }